import api from './axios-interceptor/api';
import download from 'downloadjs';

const library = {
  downloadImage(file, setLoaded) {
    if (setLoaded) {
      setLoaded(false);
    }

    api
      .get(String(file.path).replace('http://', 'https://'), { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        if (file.ext) {
          link.setAttribute('download', `${file.name}.${file.ext}`);
        } else {
          link.setAttribute('download', `${file.name}`);
        }
        document.body.appendChild(link);
        link.click();

        if (setLoaded) {
          setLoaded(true);
        }
      })
      .catch(function (error) {
        console.log(error);

        if (setLoaded) {
          setLoaded(true);
        }
      });
  },

  downloadZip(files, setLoaded, propertyPath, url = '') {
    let fileName = 'download.zip';

    if (files.length === 1) {
      url = files[0][propertyPath];
      fileName = `${files[0].name}.${files[0].ext}`;
    } else {
      let fileIds = files.map((file, idx) => {
        return `files[${idx}]=${file.id}`;
      });
      url += fileIds.join('&');
    }
    setLoaded(false);

    api
      .get(url, { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        setLoaded(true);
      })
      .catch(function (error) {
        console.log(error);
        setLoaded(true);
      });
  },

  createFolder(data) {
    return new Promise((resolve, reject) => {
      api
        .post('/uploads/create-folder', data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          resolve();
        })
        .catch(function (error) {
          reject(error.response.data);
        });
    });
  },

  postFiles(payload) {
    return new Promise((resolve, reject) => {
      api
        .post('/uploads/file', payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          resolve();
        })
        .catch(function (error) {
          reject(error.response.data);
        });
    });
  },

  deleteFile(id) {
    return new Promise((resolve, reject) => {
      api
        .delete('/uploads/' + id, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          resolve();
        })
        .catch(function (error) {
          reject(error.response.data);
        });
    });
  },

  updateFile(id, data) {
    return new Promise((resolve, reject) => {
      api
        .put('/uploads/' + id, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          resolve();
        })
        .catch(function (error) {
          reject(error.response.data);
        });
    });
  },

  downloadPDF(art, setLoading, route) {
    setLoading(true);
    if (route === 'client-review') {
      return api
        .get(`/brand-request-client-artworks/${art.id}/download`, { responseType: 'blob' })
        .then(res => {
          if (res.status === 200) {
            const content = res.headers['content-type'];
            download(res.data, art.original_name, content);
          }
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
        });
    } else {
      return api
        .get(`/brand-request-artworks/${art.id}/download`, { responseType: 'blob' })
        .then(res => {
          if (res.status === 200) {
            const content = res.headers['content-type'];
            download(res.data, art.original_name, content);
          }
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
        });
    }
  },
};

export default library;
